import { defineMeta } from '@/registry/types';

export const snackbarMeta = defineMeta({
  name: 'Snackbar',
  level: 'molecule',
  category: 'feedback',
  classification: 'themed-mui',
  description: 'Transient, auto-dismissing notification (toast). Themed MUI Snackbar.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Snackbar',
  muiDocs: 'https://mui.com/material-ui/react-snackbar/',
  a2uiEquivalent: 'Toast',
  importPath: '@/molecules/Snackbar',
  requiredProps: ['open'],
  optionalProps: ['autoHideDuration', 'onClose', 'anchorOrigin', 'message', 'action'],
  supportedStates: ['open', 'closing', 'with-action'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Use role="alert" content (e.g. Alert child) for screen reader announcement.'],
  usageExamples: ['<Snackbar open autoHideDuration={3000} onClose={close}><Alert>...</Alert></Snackbar>'],
  antiPatterns: ['Do not use for persistent or critical messages (use Alert/Dialog).'],
  mountsSurface: 'portal',
  llmSafe: true,
  whenToUse: ['Brief confirmations, undo prompts'],
  whenNotToUse: ['Errors that need acknowledgement'],
});

export default snackbarMeta;
